<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        QA | Triggers
      </h2>
      <a v-bind:href="$route('qa.triggers.create')" class="btn btn-primary btn-lg">
        New Trigger
      </a>
    </div>
  </div>

  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Sku</th>
        <th class="hidden lg:table-cell">Title</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <template v-if="triggers.data.length" v-for="trigger in triggers.data">
        <tr>
          <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
            {{ trigger.sku }}
            <dl class="font-normal lg:hidden">
              <dt class="sr-only">Sku</dt>
              <dd class="mt-1 truncate text-gray-700">{{ trigger.sku }}</dd>
              <dt class="sr-only sm:hidden">Title</dt>
              <dd class="mt-1 truncate text-gray-500 sm:hidden">{{ trigger.title }}</dd>
            </dl>
          </td>
          <td class="hidden text-gray-500 lg:table-cell">{{ trigger.title }}</td>
          <td class="text-right">
            <a v-bind:href="$route('qa.triggers.edit', trigger.id)" class="text-primary-500 hover:text-primary-700">Edit</a>
            <span> | </span>
            <a v-bind:href="$route('qa.triggers.destroy', trigger.id)" class="text-danger-500 hover:text-danger-700">Delete</a>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="5" class="text-center">No triggers exist</td>
        </tr>
      </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="pagination" />
    </div>
  </div>
</template>

<script setup>
import Pagination from "../../../components/Pagination";

const { triggers } = defineProps(['triggers']);
const pagination = Object.assign({}, triggers);
delete pagination.data;
</script>
